const colors = {
    positive: '#4CAF50',
    warning: '#FFB74D',
    negative: '#af111c',
};

export default colors;
